let googleMapsScriptLoadingPromise: Promise<void> | null = null;

export function loadGoogleMapsApi(apiKey: string, libraries = 'places') {
  if (typeof window === 'undefined') return Promise.resolve();

  if (window.google && window.google.maps) {
    return Promise.resolve();
  }

  if (!googleMapsScriptLoadingPromise) {
    googleMapsScriptLoadingPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries}`;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve();
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }
  return googleMapsScriptLoadingPromise;
}